import axios from "axios";
import { APPCONFIG } from "../Config";
import { ACCESS_TOKEN } from "../lib/const";
import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getRoleList = (page) => {
  const res = axiosInstance.get("https://dummyjson.com/users");
  return res;
};

export const downloadImportFile = (fileName) => {
  const api = APIEndpoint.DOWNLOAD_IMPORT_FILE + `?fileName=`;
  let options = {
    responseType: "blob",
  };
  const res = axiosInstance.get(api + fileName, options);
  return res;
};

export const importFile = (file) => {
  const api = APIEndpoint.IMPORT_FILE;
  const formData = new FormData();
  formData.append("file", file);
  //formData.append("template", type);
  let options = {
    headers: { Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` },
  };

  const res = axios.post(APPCONFIG.GATEWAY_ENDPOINT + api, file, options);
  return res;
};

export const importFileFail = (value, pageValue) => {
  const api = APIEndpoint.IMPORT_FILE_FAIL;
  const payload = {
    requestObject: {
      sessionId: value,
    },
    pageValue: {
      page: pageValue.page,
      pageSize: pageValue.pageSize,
      total: pageValue.total,
      totalPage: pageValue.totalPage,
      sortBy: pageValue.sortBy,
      sortDirection: pageValue.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};
